module.exports = __webpack_public_path__ + "static/media/hihat-808.46ba2a48.wav";